module.exports = __webpack_public_path__ + "img/modern_frozen_products.2f9860c7.jpg";